export default __webpack_public_path__ + "static/bg-737398ac00554f74d2f27eb5b48f3fa6.jpg";